import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Content, Message } from 'rsuite';
import { Link } from 'react-router-dom';
import { isEmpty } from 'lodash/fp';
import * as PERMISSIONS from '../../../../constants/permissions/settings';
import { viewAccess } from '../../../../helpers/permission';
import { settingsPortalSmtpAccountPath } from '../../../Paths';
import AccessControl from '../../../../components/AccessControl';
import AccessDenied from '../../../../components/AccessDenied';
import PageHeader from '../../../../components/PageHeader';
import PageLayout from '../../../../components/settings/portal/PageLayout';
import { fetchCurrentPantry } from '../../../../redux/Settings/sagas/routines';
import {
  getIsFetching,
  getIsFetched,
  getPantry
} from '../../../../redux/Settings/selectors/portal/pantry';
import ContentLoader from '../../../../components/ContentLoader';
import PantryForm from '../../../../components/settings/portal/PantryForm';
import { useSmtpAccounts } from '../../../../hooks/useSmtpAccounts';

const CompletePantryMessage = (
  <p>
    Complete your Pantry details below and proceed to SMTP Account to enable
    reservation email notifications.
  </p>
);

const SetupSmtpAccountMessage = (
  <p>
    To enable email notifications, please proceed to{' '}
    <Link to={settingsPortalSmtpAccountPath}>set up your SMTP account.</Link>
  </p>
);

export default () => {
  const dispatch = useDispatch();
  const isFetching = useSelector(getIsFetching);
  const isFetched = useSelector(getIsFetched);
  const {
    isFetched: isFetchedSmtpAccounts,
    hasAccounts: hasSmtpAccounts
  } = useSmtpAccounts();
  const pantry = useSelector(getPantry);

  useEffect(
    () => {
      if (!isFetched) dispatch(fetchCurrentPantry());
    },
    [isFetched]
  );

  return (
    <PageLayout>
      <AccessControl
        allowOnlyFor={viewAccess(PERMISSIONS.PORTAL)}
        fallback={<AccessDenied />}
      >
        <PageHeader title="Pantry Details" />
        <Content
          style={{ marginTop: isEmpty(pantry) || !hasSmtpAccounts ? 0 : 20 }}
        >
          {isFetching && <ContentLoader />}
          {isFetchedSmtpAccounts &&
            !hasSmtpAccounts && (
              <Message
                type="info"
                description={
                  !pantry ? CompletePantryMessage : SetupSmtpAccountMessage
                }
                showIcon
                style={{ marginBottom: 16 }}
              />
            )}
          {isFetched && <PantryForm data={pantry} />}
        </Content>
      </AccessControl>
    </PageLayout>
  );
};
